import request from './request';

const announcementService = {
  getAll: (params) => request.get('dashboard/admin/announcements', { params }),
  getById: (id) => request.get(`dashboard/admin/announcements/${id}`),
  create: (data) => request.post('dashboard/admin/announcements/publish', data),
  update: (id, data) => request.put(`dashboard/admin/announcements/${id}`, data),
  delete: (params) =>
    request.delete(`dashboard/admin/announcements/delete`, { params }),
};

export default announcementService;
